module.exports = __webpack_public_path__ + "testerstatic/media/icon-bulb.264b6a38.svg";